/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { type Meta, type StoryObj } from '@storybook/react-vite';

import { IconButton } from '..';
import {
  IconButtonActive,
  IconButtonActiveSrc,
  IconButtonDefault,
  IconButtonDefaultSrc,
  IconButtonDisabled,
  IconButtonDisabledSrc,
  IconButtonFloating,
  IconButtonFloatingSrc,
  IconButtonLoading,
  IconButtonLoadingSrc,
  IconButtonSizes,
  IconButtonSizesSrc,
  IconButtonTone,
  IconButtonToneSrc,
} from '.';

const componentMeta = {
  component: IconButton,
  id: 'components-icon-button',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/IconButton',
} satisfies Meta<typeof IconButton>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  parameters: {
    docs: {
      source: {
        code: IconButtonDefaultSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: IconButtonDefault,
};

export const Active: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonActive,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonActiveSrc,
      },
    },
  },
};

export const Disabled: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonDisabled,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonDisabledSrc,
      },
    },
  },
};

export const Floating: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonFloating,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonFloatingSrc,
      },
    },
  },
};

export const Loading: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonLoading,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonLoadingSrc,
      },
    },
  },
};

export const Sizes: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonSizes,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonSizesSrc,
      },
    },
  },
};

export const Tone: Story = {
  // @ts-expect-error - args are not needed.
  args: {},
  render: IconButtonTone,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonToneSrc,
      },
    },
  },
};
